import { Component } from '@opten/compiler/metadata/component';
import { OnInit } from '@opten/compiler/metadata/lifecycle';
import { showMegaDropdown, hideMegaDropdown } from '../mega-dropdown';
import { isPad } from '../../utilities/detection';
import { getStickyOffset } from '../../utilities/scroll-helper';
import { hasClass } from '@opten/dom/has-class';
import { addClass } from '@opten/dom/add-class';
import { removeClass } from '@opten/dom/remove-class';

import { ComponentRef, ComponentRefs } from '@opten/compiler/metadata/di';
import { Navbar } from './navbar';
import { NavbarMegaDropdown } from '.';

// const mouseEnterDuration = 300;

// todo: update arias also in dekstop e.g. for mega-dropdown
@Component({ className: 'js-navbar-mega-dropdown-toggler-favorite-added' })
export class NavbarMegaDropdownFavoriteAdded implements OnInit {
    private _backdropElement: HTMLElement;
    private _dropdownElement: HTMLElement;
    private _dropdownTitleElement: HTMLElement;
    @ComponentRef(Navbar) _navbar: Navbar;
    @ComponentRefs(NavbarMegaDropdown) _dropdowns: Array<NavbarMegaDropdown>;
    private _dropdownDomainElement: HTMLElement;


    get _isOpen(): boolean {
        return hasClass(this._dropdownElement, '--show');
    }

    // used to know if we're still animating
    // private _timeout: number | null = null;

    // private _boundShow = this._handleShow.bind(this);
    // private _boundHide = this._handleHide.bind(this);

    constructor(private element: HTMLElement) {
        this._backdropElement = document.getElementsByClassName(
            'js-navbar-backdrop'
        )[0] as HTMLElement;

        this._dropdownElement = element.parentElement.getElementsByClassName('js-navbar-mega-dropdown-favorite-added')[0] as HTMLElement;
        if (this._dropdownElement) {
            const title = this._dropdownElement.getElementsByClassName(
                'js-navbar-mega-dropdown-favorite-added-title'
            );
            if (title && title.length > 0) {
                this._dropdownTitleElement = title[0] as HTMLElement;
            }
            const domain = this._dropdownElement.getElementsByClassName(
                'js-navbar-mega-dropdown-favorite-added-domain'
            );
            if (domain && domain.length > 0) {
                this._dropdownDomainElement = domain[0] as HTMLElement;
            }
        }
    }

    onInit() {
        this._handleResize();
        window.addEventListener('resize', () => this._handleResize());
        this._addDesktopListeners();

    }

    private _addDesktopListeners() {
        this._backdropElement.addEventListener(
            'click',
            this._handleBackdropClick
        );

    }

    private _setContainerHeight() {
        const container = this._dropdownElement
            .firstElementChild as HTMLElement;

        const stickyOffset = getStickyOffset();
        if (container && stickyOffset) {
            container.style.maxHeight = `calc(100vh - ${stickyOffset}px)`;
        }
    }

    private _setDropdownPosition() {
        this._dropdownElement.style.marginLeft = "0px";
        if (isPad() == false) {
            const dropdownBox = this._dropdownElement.getBoundingClientRect();
            const spacerRight = 40;
            if (dropdownBox.right > (window.innerWidth - spacerRight)) {
                this._dropdownElement.style.marginLeft = "-" + ((dropdownBox.left + dropdownBox.width) - (window.innerWidth - spacerRight)) + "px";
            }
        }

    }

    private _handleResize() {
        this.hide();
        this._setContainerHeight();
        this._setDropdownPosition();
    }

    public show(title: string, domain: string) {
        if (this._dropdownTitleElement) {
            this._dropdownTitleElement.innerHTML = title;
        }
        if (this._dropdownDomainElement) {
            this._dropdownDomainElement.innerHTML = domain;
        }
        this._handleResize();
        if (this._isOpen) {
            return;
        }
        addClass(this._navbar.navbarElement, '--mega-dropdown--open');

        // check if another one is open, to hide it except the backdrop
        this._dropdowns.forEach(dropdown => dropdown.hide());

        showMegaDropdown(this._dropdownElement, this._backdropElement, () => this.hide(),4500);
    }

    public hide() {
        if (!this._isOpen) {
            return;
        }
        removeClass(this._navbar.navbarElement, '--mega-dropdown--open');


        hideMegaDropdown(this._dropdownElement, this._backdropElement);
    }

    private _handleBackdropClick = (event: MouseEvent) => {
        event.preventDefault();

        this.hide();
    }
}
